import { useState } from "react";
import { FiMail } from "react-icons/fi";
import SendEmailForm from "../common/SendEmailFrom";

function ContactSupportExecution({
  runbookName,
  executionId,
  startTime,
  endTime,
  user,
}) {
  const supportEmail =
    import.meta.env.VITE_SUPPORT_EMAIL || "supportservices@armanino.com";
  const currentUrl = `${window.location.origin}/runbook/executions/lines?executionId=${executionId}`;

  const [showModal, setShowModal] = useState(false);

  const emailDetails = {
    fromMail: user?.email || "",
    fromName: `${user?.firstName || ""} ${user?.lastName || ""}`,
    toMail: supportEmail,
    subject: `CloudSync Support - ${runbookName}`,
    body: `Runbook Name: ${runbookName}\nExecution ID: ${executionId}\nStart Time: ${startTime}\nEnd Time: ${endTime}\nExecution Details: ${currentUrl}\n\nPlease provide additional details if needed.`,
  };
  
  return (
    <>
      <span
        className="text-primary text-nowrap"
        style={{ textDecoration: "none", cursor: "pointer" }}
        onClick={() => setShowModal(true)}
      >
        <FiMail className="mb-1 me-2" />
        Contact Support
      </span>

      {showModal && (
        <SendEmailForm
          show={showModal}
          onHide={() => setShowModal(false)}
          emailDetails={emailDetails}
          user={user}
        />
      )}
    </>
  );
}

export default ContactSupportExecution;
